const FALLBACK_LABEL = 'defects'

export default (report) => {
  const label = report?.attributes?.settings?.deficiencies_label

  if (typeof label !== 'string') return FALLBACK_LABEL

  return label.trim().toLowerCase() || FALLBACK_LABEL
}
